import { render, staticRenderFns } from "./ReconhecimentoFacial.vue?vue&type=template&id=68bf512c&scoped=true&"
import script from "./ReconhecimentoFacial.vue?vue&type=script&lang=js&"
export * from "./ReconhecimentoFacial.vue?vue&type=script&lang=js&"
import style0 from "./ReconhecimentoFacial.vue?vue&type=style&index=0&id=68bf512c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf512c",
  null
  
)

export default component.exports